import { InformationCircleIcon } from '@heroicons/react/outline';

export default function HelpIcon() {
  return <InformationCircleIcon className="h-6 w-6 inline-block" />;
}
